import React from "react";
import { useLocation, useParams } from "react-router-dom";
import { Dropdown, Menu } from "antd";
import "antd";
import "./Header.css";
import AuthService from "../../Auth";
import { useNavigate } from "react-router-dom";
import { APP_CONFIG } from "../../AppConfig";
import profile from "../../images/profile.png";
import { FaBars, FaCaretDown } from "react-icons/fa";
import logo1 from "../../images/logoWide.png";
import { useSelector, useDispatch } from "react-redux";
import { resetState, setLoading, setFetchedClient } from "../../redux/actions"; 

const Header = () => {
  const location = useLocation();
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isDashboardPage = location.pathname === "/" || "/:id";
  const client = useSelector((state) => state.fetchedClient);

  const handleSignOut = async () => {
    try {
      const url = new URL(window.location.href);
      const encodedRedirectUrl = encodeURIComponent(url);
      await AuthService.logout();
      dispatch(resetState());
      window.location.href = `${APP_CONFIG.SIGNIN_URL}?redirect_url=${encodedRedirectUrl}`;
    } catch (error) {
      console.log("Error signing out: ", error);
    }
  };

  const handleSwitchProfile = () => {
    dispatch(resetState());
    navigate("/");
  };

  const menu = (
    <Menu>
      <Menu.Item key="name">{`${client?.firstName} ${client?.lastName}`}</Menu.Item>
      <Menu.Divider key="divider1" />
      <Menu.Item key="switchProfiles" onClick={handleSwitchProfile}>
        Switch Profiles
      </Menu.Item>
      <Menu.Divider key="divider2" />
      <Menu.Item key="signOut" onClick={handleSignOut}>
        Sign Out
      </Menu.Item>
    </Menu>
  );

  return (
    <header className="header" style={{ backgroundColor: "#009EFB" }}>
      <div className="header-logo">
        <img src={logo1} alt="Logo" />
      </div>
      {isDashboardPage && (
        <div className="header-right">
          {client ? (
            <Dropdown overlay={menu} placement="bottomRight">
              <div
                className="nav-item has-arrow user-noti"
                style={{ color: "white", fontWeight: "bold" }}
              >
                <img
                  src={profile}
                  style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "50%",
                    marginRight: "8px",
                  }}
                  alt=""
                  className="profile-image"
                />
                {`${client.firstName} ${client.lastName}`}
              </div>
            </Dropdown>
          ) : (
            <div
              className="nav-item user-noti"
              style={{ color: "white", fontWeight: "bold" }}
            >
              Loading...
            </div>
          )}
          <FaCaretDown style={{ marginRight: "8px", color: "white" }} />
        </div>
      )}
    </header>
  );
};

export default Header;
